var _classCallCheck = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _slicedToArray = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var Bmob = require('./bmob');

var Error = require('./error');

var Emitter = {
  setup: function setup(target) {
    var listeners = [];
    Object.assign(target, {
      on: function on(type, handle) {
        if (typeof handle === 'function') {
          listeners.push([type, handle]);
        }
      },
      emit: function emit(type) {
        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }

        listeners.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              listenType = _ref2[0],
              handle = _ref2[1];

          return type === listenType && handle.apply(void 0, params);
        });
      },
      removeAllListeners: function removeAllListeners() {
        listeners = [];
      }
    });
  }
};
/**
 * 基于小程序 WebSocket 接口封装信道
 */

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function socket() {
    _classCallCheck(this, socket);

    if (!Bmob._config.applicationId) {
      throw new Error(415);
    }

    this.config = {
      host: 'wss.bmobcloud.com'
    };
    Emitter.setup(this.emitter = {});
    this.applicationId = Bmob._config.applicationId;
    this.initialize();
  }

  _createClass(socket, [{
    key: "handshake",
    value: function handshake() {
      function complete(data) {
        if (data instanceof Error) {
          self.connecting = false;
          self.onError(data.message);
        } else {
          return data.split(':')[0];
        }
      }

      var url = 'https://' + this.config.host + '/socket.io/1/?t=' + new Date().getTime();
      var dataObject = {};
      var data = JSON.stringify(dataObject);
      var method = 'GET';
      return new Promise(function (resolve, reject) {
        wx.request({
          method: method,
          url: url,
          data: data,
          header: {
            'content-type': 'text/plain'
          },
          success: function success(res) {
            if (res.data && res.data.statusCode) {
              return resolve('request error', e);
            } else if (res.statusCode !== 200) {
              return resolve('request error', e);
            } else {
              return resolve(complete(res.data));
            }
          },
          fail: function fail(e) {
            return resolve('request error', e);
          }
        });
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this = this;

      this.handshake().then(function (protocol) {
        try {
          _this.connect("wss://".concat(_this.config.host, "/socket.io/1/websocket/") + protocol, {});
        } catch (connectError) {
          console.error({
            connectError: connectError
          });
          throw connectError;
        }
      });
      this.on('close', function () {
        console.log('连接已中断');
      });
      return new Promise(function (resolve, reject) {
        _this.on('server_pub', function (data) {
          switch (data.action) {
            case 'updateTable':
              _this.onUpdateTable(data.tableName, data.data);

              break;

            case 'updateRow':
              _this.onUpdateRow(data.tableName, data.objectId, data.data);

              break;

            case 'deleteTable':
              _this.onDeleteTable(data.tableName, data.data);

              break;

            case 'deleteRow':
              _this.onDeleteRow(data.tableName, data.objectId, data.data);

              break;
          }
        }); // 连接上socket.io服务器后触发的事件


        _this.on('client_send_data', function (resp) {
          _this.onInitListen();
        });
      });
    }
  }, {
    key: "onInitListen",
    value: function onInitListen() {}
  }, {
    key: "connect",
    value: function connect(url, header) {
      var _this2 = this;

      // 小程序 wx.connectSocket() API header 参数无效，把会话信息附加在 URL 上
      var query = Object.keys(header).map(function (key) {
        return "".concat(key, "=").concat(encodeURIComponent(header[key]));
      }).join('&');
      var seperator = url.indexOf('?') > -1 ? '&' : '?';
      url = [url, query].join(seperator);
      return new Promise(function (resolve, reject) {
        wx.onSocketOpen(resolve);
        wx.onSocketError(reject);
        wx.onSocketMessage(function (packet) {
          try {
            var filter = function filter(str) {
              var _JSON$parse = JSON.parse(str),
                  name = _JSON$parse.name,
                  args = _JSON$parse.args;

              return {
                name: name,
                args: args
              };
            };

            var str = packet.data;
            var startStr = str.slice(0, 4); // 检测心跳

            if (startStr === '2:::') {
              _this2.emit(false, true);
            }

            str = str.slice(4); // 截取后不能为空

            if (str === null || str === '') {
              return;
            }

            var _filter = filter(str),
                name = _filter.name,
                args = _filter.args;

            var data = args == null ? '' : JSON.parse(args[0]);

            _this2.emitter.emit(name, data);
          } catch (e) {
            console.log('Handle packet failed: ' + packet.data, e);
          }
        });
        wx.onSocketClose(function () {
          return _this2.emitter.emit('close');
        });
        wx.connectSocket({
          url: url,
          header: header
        });
      });
    }
  }, {
    key: "on",
    value: function on(message, handle) {
      this.emitter.on(message, handle);
    }
  }, {
    key: "emit",
    value: function emit(message, data) {
      data = data === undefined ? '5:::' : '2:::';
      message = message ? JSON.stringify(message) : '';
      wx.sendSocketMessage({
        data: data + message
      });
    }
  }, {
    key: "emitData",
    value: function emitData(name, data) {
      data = JSON.stringify(data);
      return {
        name: name,
        args: [data]
      };
    }
  }, {
    key: "updateTable",
    value: function updateTable(tablename) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: '',
        action: 'updateTable'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 取消订阅更新数据表的数据

  }, {
    key: "unsubUpdateTable",
    value: function unsubUpdateTable(tablename) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: '',
        action: 'unsub_updateTable'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 订阅行更新的数据

  }, {
    key: "updateRow",
    value: function updateRow(tablename, objectId) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: objectId,
        action: 'updateRow'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 取消订阅行更新的数据

  }, {
    key: "unsubUpdateRow",
    value: function unsubUpdateRow(tablename, objectId) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: objectId,
        action: 'unsub_updateRow'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 订阅表删除的数据

  }, {
    key: "deleteTable",
    value: function deleteTable(tablename) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: '',
        action: 'deleteTable'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 取消订阅表删除的数据

  }, {
    key: "unsubDeleteTable",
    value: function unsubDeleteTable(tablename) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: '',
        action: 'unsub_deleteTable'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 订阅更新数据表的数据

  }, {
    key: "deleteRow",
    value: function deleteRow(tablename, objectId) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: objectId,
        action: 'deleteRow'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 订阅更新数据表的数据

  }, {
    key: "unsubDeleteRow",
    value: function unsubDeleteRow(tablename, objectId) {
      var data = {
        appKey: this.applicationId,
        tableName: tablename,
        objectId: objectId,
        action: 'unsub_deleteRow'
      };
      data = this.emitData('client_sub', data);
      this.emit(data);
    } // 监听服务器返回的更新数据表的数据，需要用户重写

  }, {
    key: "onUpdateTable",
    value: function onUpdateTable(tablename, data) {} // 监听服务器返回的更新数据表的数据，需要用户重写

  }, {
    key: "onUpdateRow",
    value: function onUpdateRow(tablename, objectId, data) {} // 监听服务器返回的更新数据表的数据，需要用户重写

  }, {
    key: "onDeleteTable",
    value: function onDeleteTable(tablename, data) {} // 监听服务器返回的更新数据表的数据，需要用户重写

  }, {
    key: "onDeleteRow",
    value: function onDeleteRow(tablename, objectId, data) {}
  }]);

  return socket;
}();